import type { ReactNode, SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export function SvgComputerVerification({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): ReactNode {
  return (
    <svg
      aria-labelledby={titleId}
      fill="none"
      height={80}
      viewBox="0 0 80 80"
      width={80}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.469 25.476a.55.55 0 0 0-.25.433v32.505c0 .082.03.139.077.164l.864.494c.045.026.107.022.176-.018l40.41-23.33a.55.55 0 0 0 .25-.434V2.785q-.002-.116-.067-.159l-.867-.496c-.046-.03-.11-.027-.183.015z"
        fill="#1A1A1A"
        stroke="#1A1A1A"
        strokeWidth={0.8}
      />
      <path
        d="M5.086 26.405a.55.55 0 0 1 .25-.433L45.746 2.64c.139-.08.25-.015.25.144V35.29c0 .16-.111.354-.25.433L5.337 59.054c-.138.08-.25.015-.25-.144z"
        fill="#fff"
        stroke="#1A1A1A"
        strokeWidth={0.8}
      />
      <path
        d="m46.02 37.628.125-.056c.265-.095.602-.097.871-.006l.129.053L74.91 51.6l.065.037c.123.077.2.174.22.278l.003.052v1.9c0 .13-.088.253-.246.345L34.396 77.626c-.329.19-.864.19-1.193 0L5.43 61.593c-.158-.091-.247-.215-.247-.345V59.49l.019-.1a.5.5 0 0 1 .255-.258z"
        fill="#D5C8FF"
        stroke="#1A1A1A"
        strokeWidth={0.8}
      />
      <rect
        fill="#fff"
        height={33.277}
        rx={0.689}
        stroke="#1A1A1A"
        strokeWidth={0.8}
        transform="matrix(.86603 -.5 .86603 .5 5.585 58.879)"
        width={48.04}
        x={-0.693}
      />
      <rect
        fill="#D5C8FF"
        height={8.314}
        rx={0.289}
        stroke="#1A1A1A"
        strokeWidth={0.8}
        transform="matrix(-.86603 .5 .86603 .5 50.834 53.425)"
        width={16.005}
      />
      <path
        d="m22.848 63.644 30.977-17.885M18.518 61.145 49.495 43.26M14.188 58.645 45.165 40.76"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M30 19.046v18.832c0 .264.131.482.32.613l1.027.595a.74.74 0 0 0 .738-.005l23.414-13.548a.75.75 0 0 0 .372-.645V6.075a.74.74 0 0 0-.367-.642l-.993-.573a.74.74 0 0 0-.725.012L30.372 18.4a.75.75 0 0 0-.372.645"
        fill="#1A1A1A"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M31.096 38.254V19.768c0-.32.17-.614.446-.774L54.658 5.636a.894.894 0 0 1 1.341.774v18.47c0 .318-.17.613-.446.773L32.438 39.028a.894.894 0 0 1-1.342-.774"
        fill="#FFC9A6"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="m46.55 18.56 6.101-3.63m-6.101 7.684 6.101-3.63"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M39.107 25.138c-2.782 1.655-5.037 5.84-5.037 9.346l10.074-5.993c0-3.507-2.255-5.008-5.037-3.353"
        fill="#fff"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <circle
        cx={2.93}
        cy={2.93}
        fill="#fff"
        r={2.93}
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeWidth={0.8}
        transform="matrix(.8594 -.5113 0 1 36.58 20.752)"
      />
    </svg>
  );
}
